import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=414a8d0b&scoped=true&"
import script from "./DataBoard.vue?vue&type=script&lang=js&"
export * from "./DataBoard.vue?vue&type=script&lang=js&"
import style0 from "./DataBoard.vue?vue&type=style&index=0&id=414a8d0b&scoped=true&lang=css&"
import style1 from "./DataBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414a8d0b",
  null
  
)

component.options.__file = "DataBoard.vue"
export default component.exports